import { render } from "./chatView.vue?vue&type=template&id=686ec79a&scoped=true"
import script from "./chatView.vue?vue&type=script&lang=js"
export * from "./chatView.vue?vue&type=script&lang=js"

import "./chatView.vue?vue&type=style&index=0&id=686ec79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686ec79a"]])

export default __exports__